import OtherLiensBalanceFieldLabel from "./OtherLiensBalanceFieldLabel";

export default function OtherLiensBalanceModalField({ className = "", label, renderValue }) {
  return (
    <div className={`flex w-full flex-col gap-1 ${className}`}>
      <OtherLiensBalanceFieldLabel value={label} />
      {renderValue}
    </div>
  );
}

